module.exports = __webpack_public_path__ + "static/img/maskCount_green.ba33e699.png";